import React from 'react'
import { makeStyles } from '@material-ui/styles'
import { Button } from '@material-ui/core'
import PersonAdd from '@material-ui/icons/PersonAdd'

const useStyles = makeStyles(theme => ({
	buttonAdd: {
		color: theme.palette.primary.main,
		display: 'block',
		border: 0,
		margin: '0 auto',
		marginTop: '20px',
	},
	addIcon: {
		width: '2em',
		height: '2em',
	},
}))

function FormButtonIconAdd({ label, type, onClick, children, ...props }) {
	const classes = useStyles()

	return (
		<Button
			className={classes.buttonAdd}
			type={type}
			variant="outlined"
			onClick={onClick}
			{...props}
		>
			<PersonAdd className={classes.addIcon} />
		</Button>
	)
}

export default FormButtonIconAdd
